import { Component, EventEmitter, input, Output, TemplateRef, ViewChild } from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatButtonColors, MatButtonType } from '@shared/models/z-button.model';
import { MatButton, MatFabButton, MatMiniFabButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'z-button',
    templateUrl: './z-button.component.html',
    styleUrls: ['./z-button.component.scss'],
    imports: [
        MatButton,
        RouterLink,
        MatMenuTrigger,
        NgClass,
        MatTooltip,
        MatIcon,
        MatFabButton,
        MatMiniFabButton,
        TranslatePipe,
    ],
})
export class ZButtonComponent {
  readonly MatButtonType = MatButtonType;
  readonly MatButtonColors = MatButtonColors;
  readonly id = input<string>('');
  readonly icon = input<string>('');
  readonly color = input<
    'primary' | 'secondary' | 'accent' | 'warn' | 'error' | 'success' | 'info'
  >(MatButtonColors.PRIMARY as any);
  readonly label = input<string>('');
  readonly matType = input<
    'flat' | 'raised' | 'stroked' | 'menu' | 'fab' | 'mini-fab' | 'extended-fab'
  >(MatButtonType.FLAT);
  readonly tooltip = input<string>('');
  readonly ariaLabel = input<string>('');
  readonly menuTriggerFor = input<MatMenu | null>(null);
  readonly customLabel = input<TemplateRef<unknown>>();
  readonly routerLink = input<string>('');
  readonly outline = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly buttonType = input<string>('button');
  readonly queryParams = input<Params>();

  readonly href = input<string>('');
  readonly target = input<string>('');
  readonly rel = input<string>('noopener noreferrer');

  @Output()
  clicked: EventEmitter<Event> = new EventEmitter();

  @ViewChild(MatMenuTrigger)
  private matMenuTriggerRef?: MatMenuTrigger;

  isFabType(): boolean {
    return (
      this.matType() === MatButtonType.FAB ||
      this.matType() === MatButtonType.MINI_FAB ||
      this.matType() === MatButtonType.EXTENDED_FAB
    );
  }

  isLinkMode(): boolean {
    return !!this.href() && !this.disabled() && !this.menuTriggerFor();
  }

  resolvedTooltip(): string {
    return this.tooltip() || this.label();
  }

  resolvedAriaLabel(): string {
    return this.ariaLabel() || this.label() || this.tooltip();
  }

  emitClick(event: Event): void {
    if (this.disabled()) {
      return;
    }
    this.clicked.emit(event);
  }

  closeMenu(): void {
    this.matMenuTriggerRef?.closeMenu();
  }
}
